import moment from 'moment';
moment.relativeTimeThreshold('ss', 10);
class AutosaveService {
    lastSave: any;
    lastSaveTimer: any;
    _isSaveFinished: boolean;
    spinSaveTimer: any;
    _$pop: JQuery;
    count: number = 0;


    async saving(promise) {
        this.saveStarted();
        let response = await promise;
        // console.log(response);
        this.saveFinished();
        return response;
    }

    get isSaveFinished() {
        return this._isSaveFinished;
    }
    set isSaveFinished(value) {
        this._isSaveFinished = value;
        if (!value) {
            this.setAnimatedTimer();
        }
    }

    get $pop() {
        if (!this._$pop) {
            this._$pop = $('.pop');
        }
        return this._$pop;
    }

    private setAnimatedTimer() {
        if (this.spinSaveTimer) {
            clearTimeout(this.spinSaveTimer);
        }
        if (!this.isSaveFinished) {
            this.spinSaveTimer = setTimeout(() => this.setAnimatedTimer(), 1000);
        } else {
            this.$pop.fadeTo(1000, 0.2, () => {
                // this.$pop.css({'visibility': 'visible', 'opacity': 0.2);
                this.$pop.closest('.animation-div').removeClass('animated');
            });
        }
    }

    activateAnimation() {
        let $autoSaveIndicators = this.$pop.closest('.animation-div');
        $autoSaveIndicators.fadeTo(500, 1.0);
        this.$pop.css('display', 'inline-block');
    }

    saveStarted() {
        this.count++;
        // console.log(this.count, "save started");
        if (this.count === 1) {
            this.$pop.fadeTo(1000, 1);
            this.$pop.closest('.animation-div').addClass('animated');
            this.isSaveFinished = false;
            let $saveStatus = $('.auto-save');
            $saveStatus.fadeOut(600);
            $saveStatus.text('');
        }
    }

    saveFinished() {
        this.count--;
        // console.log(this.count, "save finished");
        if (this.count == 0) {
            this.isSaveFinished = true;
            this.lastSave = moment();
            if (this.lastSaveTimer) {
                clearTimeout(this.lastSaveTimer);
                this.lastSaveTimer = null;
            }
            this.updateLastSaveTime();
        }
    }

    private updateLastSaveTime() {
        let $saveStatus = $('.auto-save');
        let justNow = null;
        if (this.lastSaveTimer == null) {
           justNow = 'just now';
        }
        let secondsSince = moment().diff(this.lastSave, 'minutes');

        $saveStatus.fadeOut(100,  () => {
            $saveStatus.addClass('past');
            $saveStatus.text(`Autosaved ${ justNow ? justNow : this.lastSave.fromNow() }`);
            $saveStatus.fadeIn(600);
        });

        let timeout = justNow ? 5000 : 25000;
        if (secondsSince <= 10) {
        } else if (secondsSince <= 60) {
            timeout = 300000;
        } else {
            timeout = 3600000;
        }

        this.lastSaveTimer = setTimeout(() => this.updateLastSaveTime(), timeout);
    }

    reset() {
        this._$pop = null;
        this.count = 0;
        if (this.lastSaveTimer) {
            clearTimeout(this.lastSaveTimer);
            this.lastSaveTimer = null;
        }
        if (this.spinSaveTimer) {
            clearTimeout(this.spinSaveTimer);
            this.spinSaveTimer = null;
        }
    }
}

const autosaveService = new AutosaveService();
export default autosaveService;


$(document).on('turbo:load', () => autosaveService.reset());